import { useMutation } from "@tanstack/react-query";
import { directDebitPay } from "src/services";
import { CheckoutError } from "src/types/error";

const useDirectDebitPay = () => {
  return useMutation<
    CheckoutType,
    CheckoutError,
    { token: string | undefined; data: DirectDebitRequestType }
  >({
    mutationFn: ({ token, data }) => directDebitPay(token, data),
  });
};

export default useDirectDebitPay;
